module.exports = require('react-modal-hook')
